
export class FurnaceTemperature {
  constructor({
    id = null,
    day = '',
    time = ``,
    locName = ``,
    locId = ``,
    furnaceNumber = ``,
    position12C = '',
    position12H = '',
    position22C = '',
    position22H = '',
    position32C = '',
    position32H = '',
    position150C = '',
    position150H = '',
    position152C = '',
    position152H = '',
    position153C = '',
    position153H = '',
    position155C = '',
    position155H = '',
    position250C = '',
    position250H = '',
    position251C = '',
    position251H = '',
    position252C = '',
    position252H = '',
    position253C = '',
    position253H = '',
    position254C = '',
    position254H = '',
    position255C = '',
    position255H = '',
   
  } = {}) {
    this.id = id;
    this.day = day;
    this.time = time;
    this.locName = locName;
    this.locId = locId;
    this.furnaceNumber = furnaceNumber;
    this.position12C = position12C;
    this.position12H = position12H;
    this.position22C = position22C;
    this.position22H = position22H;
    this.position32C = position32C;
    this.position32H = position32H;
    this.position150C = position150C;
    this.position150H = position150H;
    this.position152C = position152C;
    this.position152H = position152H;
    this.position153C = position153C;
    this.position153H = position153H;
    this.position155C = position155C;
    this.position155H = position155H;
    this.position250C = position250C;
    this.position250H = position250H;
    this.position251C = position251C;
    this.position251H = position251H;
    this.position252C = position252C;
    this.position252H = position252H;
    this.position253C = position253C;
    this.position253H = position253H;
    this.position254C = position254C;
    this.position254H = position254H;
    this.position255C = position255C;
    this.position255H = position255H;

  }
}

/**
 * 配置参数说明, 使用 TS 语法描述类型，
 * 其中 ? 表示该参数是可选参数
 * 
 * class Config<T> { // T 为该属性的类型
 *   key: string; // 实体属性名称，决定编辑的是哪个属性
 *   label: string; // 国际化，决定文本框旁边显示的内容
 *   sortable: boolean; // MMFTable 的参数，我也不知道 FIXME:
 *   form: {
 *     type: string; // 编辑方式，可以为：input(输入框)，select(选择框)
 *     input?: string; // 输入方式（仅在 type == 'input' 时生效），可以为: text(默认)，date，time
 *   }
 *   callback?: Callback<T>;
 * }
 * interface Callback<T> { // 回调函数
 *   // 当前属性被更改，vue 自动更新视图时触发
 *   // 读取属性值，并返回其在输入框中显示的值
 *   // 默认为 _.identity 即显示和存储中的内容相同
 *   // 常见的特殊情况为：存储为 2019/01/01 显示为 2019-01-01
 *   // 此时 getter 就是 v => v.replace(/\//g, '-')
 *   getter: (storeValue: T) => string;
 *   // input 框中内容被修改，vue 写入到 entity 时触发
 *   // 与 getter 构成反函数
 *   setter: (viewValue: string) => T;
 *   // save 函数被调用前触发，如果返回 false 则不再执行后续保存操作
 *   // 决定是否保存
 *   // 如空值检查为 _.identity
 *   check: (v: T) => boolean;
 *   // 点击保存按钮后触发，返回值将会被发送给后端，并会修改 entity 中的数值
 *   // 理论上可以替换 getter-setter 函数
 *   save: (v: T) => T;
 * }
 */
export function gridFields() {
  return Object.freeze([
    {
      key: 'day',
      label: 'lbl.basic.date',
      sortable: true,
      form: {
        type: 'datepicker',
      }
    },
    {
      key: 'time',
      label: 'lbl.basic.datetime',
      sortable: true,
      form: {
        type: 'timepicker',
      }
    },
    {
      key: 'locName',
      label: 'lbl.fm.locationName',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'furnaceNumber',
      label: 'lbl.basic.furnaceName',
      sortable: true,
      form: {
        type: 'input'
      }
  },
    {
      key: 'position12C',
      label: 'lbl.furnaceTemperature.position12C',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'position12H',
      label: 'lbl.furnaceTemperature.position12H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'position22C',
      label: 'lbl.furnaceTemperature.position22C',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'position22H',
      label: 'lbl.furnaceTemperature.position22H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position32C',
        label: 'lbl.furnaceTemperature.position32C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position32H',
      label: 'lbl.furnaceTemperature.position32H',
      sortable: true,
      form: {
        type: 'input'
      }
  },
    {
        key: 'position150C',
        label: 'lbl.furnaceTemperature.position150C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position150H',
      label: 'lbl.furnaceTemperature.position150H',
      sortable: true,
      form: {
        type: 'input'
      }
  },
    {
        key: 'position152C',
        label: 'lbl.furnaceTemperature.position152C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position152H',
      label: 'lbl.furnaceTemperature.position152H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'position153C',
      label: 'lbl.furnaceTemperature.position153C',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position153H',
        label: 'lbl.furnaceTemperature.position153H',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
        key: 'position155C',
        label: 'lbl.furnaceTemperature.position155C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position155H',
      label: 'lbl.furnaceTemperature.position155H',
      sortable: true,
      form: {
        type: 'input'
      }
  },
    {
        key: 'position250C',
        label: 'lbl.furnaceTemperature.position250C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position250H',
      label: 'lbl.furnaceTemperature.position250H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position251C',
        label: 'lbl.furnaceTemperature.position251C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position251H',
      label: 'lbl.furnaceTemperature.position251H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position252C',
        label: 'lbl.furnaceTemperature.position252C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position252H',
      label: 'lbl.furnaceTemperature.position252H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position253C',
        label: 'lbl.furnaceTemperature.position253C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position253H',
      label: 'lbl.furnaceTemperature.position253H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position254C',
        label: 'lbl.furnaceTemperature.position254C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position254H',
      label: 'lbl.furnaceTemperature.position254H',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
        key: 'position255C',
        label: 'lbl.furnaceTemperature.position255C',
        sortable: true,
        form: {
          type: 'input'
        }
    },
    {
      key: 'position255H',
      label: 'lbl.furnaceTemperature.position255H',
      sortable: true,
      form: {
        type: 'input'
      }
    }

  ]);
}

export const fields = Object.freeze(Object.keys(new FurnaceTemperature()).map(i => 'entity.' + i));

export const filterFields = [
  'filter.startTimeFilter',
  'filter.endTimeFilter',
  'filter.furnaceNumberFilter',
  'filter.locNameFilter',
];

export const filter = {
  'startTimeFilter': "",
  'endTimeFilter':"",
  'furnaceNumberFilter':"default",
  'locNameFilter': "default",
};